'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncFetchThreadHistory = undefined;
exports.fetchThreadHistory = fetchThreadHistory;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _createDeprecatedAsyncAction = require('conversations-async-data/async-action/createDeprecatedAsyncAction');

var _prepareThreadHistoryResponse = require('../operators/prepareThreadHistoryResponse');

var _fetchThreadHistoryClient = require('../clients/fetchThreadHistoryClient');

var _ActionTypes = require('../constants/ActionTypes');

var _getSenderPairs = require('../operators/getSenderPairs');

var _AgentResponderActions = require('../../actions/AgentResponderActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var asyncFetchThreadHistory = exports.asyncFetchThreadHistory = (0, _createDeprecatedAsyncAction.createDeprecatedAsyncAction)({
  requestFn: _fetchThreadHistoryClient.fetchThreadHistoryClient,
  actionTypes: _ActionTypes.FETCH_THREAD_HISTORY,
  toRecordFn: _prepareThreadHistoryResponse.prepareThreadHistoryResponse
});

function fetchThreadHistory(_ref) {
  var startTime = _ref.startTime,
      threadId = _ref.threadId,
      sessionId = _ref.sessionId;

  return function (dispatch) {
    dispatch(asyncFetchThreadHistory({ startTime: startTime, threadId: threadId, sessionId: sessionId })).then(function (_ref2) {
      var payload = _ref2.payload;

      var threadHistory = (0, _getIn2.default)(['data', 'threadHistory'], payload);
      var responders = (0, _getSenderPairs.getSenderPairs)(threadHistory);
      responders.forEach(function (senderPair) {
        var senderId = (0, _getIn2.default)(['senderId'], senderPair);
        var senderType = (0, _getIn2.default)(['senderType'], senderPair);
        dispatch((0, _AgentResponderActions.fetchAgentResponderIfNecessary)({ senderId: senderId, senderType: senderType }));
      });
    });
  };
}